export default __webpack_public_path__ + "static/media/000_intro_part2.e5cb76e6.mp4";